module.exports = __webpack_public_path__ + "static/media/dragon.a3db5f65.png";